import { Controller } from 'stimulus'
import { useDispatch } from 'stimulus-use'
import { useBusItem } from '@app/javascript/controllers/mixins/useBusItem.js'

export default class extends Controller {
  static targets = ['filter', 'form']

  static values = { reload: Boolean }

  connect() {
    this.element[this.identifier] = this
    useDispatch(this)
    useBusItem(this)
  }

  clearAll(ev) {
    const reloadValue = this.reloadValue

    this.filterTargets
      .filter(filter => !filter.classList.contains('hidden'))
      .forEach((elem) => {
        // skip clearing search input field on filters clearAll
        if (ev?.currentTarget?.getAttribute('data-id') === 'filters_clear_all_btn' && elem.classList.contains('search-filter')) return
        elem.filter.clearAll(reloadValue)
      })

    this.dispatch('filtersCleared')

    if (this.hasFormTarget) {
      this.formTarget.dispatchEvent(new CustomEvent('filters-container:filterCleared'))
    }
  }

  appendSerializedFilterForm(event) {
    $(event.target.parentElement).appendAttr('action', '?' + $(this.formTarget).serialize())
  }

  getFormTarget() {
    return this.formTarget
  }
}
